import React from 'react';

const RiskGuruMindmap = () => {
  return (
    <div style={{ width: '100%', height: '100vh', margin: 0, padding: 0, overflow: 'hidden' }}>
      <iframe
        src="/riskguru_feature_mindmap.html"
        style={{
          width: '100%',
          height: '100%',
          border: 'none',
          display: 'block'
        }}
        title="RiskGuru Feature Mind Map"
      />
    </div>
  );
};

export default RiskGuruMindmap;

